import React from 'react'
import {Form, FastField} from 'formik'

import AdvancedSearch from './AdvancedSearch.styled'
import Select from '~/components/formComponents/Select'
import PriceRangeSelect from './PriceRangeSelect'
import AreaRange from './AreaRange'
import {inputFieldCss} from './constants'

const AdvancedSearchComponent = (props) => {
  const {
    isDistrictNotSet,
    categoryOptions,
    districtOptions,
    wardOptions,
    streetOptions,
    directionOptions,
    priceOptions,
    disabledSearchBtn,
  } = props

  return (
    <Form>
      <AdvancedSearch>
        <AdvancedSearch.Left>
          <AdvancedSearch.FieldWrapper>
            <Select
              name='category'
              label='Loại bất động sản'
              options={categoryOptions}
            />
          </AdvancedSearch.FieldWrapper>

          <AdvancedSearch.FieldWrapper>
            <Select
              name='district'
              label='Quận/Huyện'
              options={districtOptions}
            />
          </AdvancedSearch.FieldWrapper>

          <AdvancedSearch.FieldWrapper>
            <Select
              name='ward'
              label={isDistrictNotSet ? 'Chọn Quận/Huyện trước' : 'Phường'}
              options={wardOptions}
              disabled={isDistrictNotSet}
            />
          </AdvancedSearch.FieldWrapper>

          <AdvancedSearch.FieldWrapper>
            <Select
              name='street'
              label='Đường'
              options={streetOptions}
            />
          </AdvancedSearch.FieldWrapper>

          <AdvancedSearch.FieldWrapper>
            <Select
              name='direction'
              label='Hướng nhà'
              options={directionOptions}
            />
          </AdvancedSearch.FieldWrapper>

          <AdvancedSearch.FieldWrapper>
            <PriceRangeSelect
              label='Mức giá'
              options={priceOptions}
            />
          </AdvancedSearch.FieldWrapper>

          <AdvancedSearch.FieldWrapper>
            <AreaRange />
          </AdvancedSearch.FieldWrapper>

          <AdvancedSearch.FieldWrapper>
            <FastField
              css={inputFieldCss}
              name='keyword'
              placeholder='Từ khoá'
            />
          </AdvancedSearch.FieldWrapper>
        </AdvancedSearch.Left>

        <AdvancedSearch.Right disabled={disabledSearchBtn}>Tìm kiếm</AdvancedSearch.Right>
      </AdvancedSearch>
    </Form>
  )
}

export default AdvancedSearchComponent
